import produce from 'immer';

const INITIAL_STATE = {
  opened: false,
};

export default function dialogForm(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@dialogform/OPEN': {
        draft.opened = true;
        break;
      }

      // Adicionar case
      case '@dialogform/CLOSE':
      case '@operacaovazaonaoautorizada/SUCCESS_REMOVE_FORM':
      case '@operacaotransferencia/SUCCESS_REMOVE_FORM':
      case '@operacaoLubrificacao/SUCCESS_REMOVE_FORM':
      case '@operacaoabastecimento/SUCCESS_REMOVE_FORM': {
        draft.opened = false;
        break;
      }

      default:
    }
  });
}
